module.exports = __webpack_public_path__ + "fonts/Inter-Medium.293fd13.woff2";